import { TrackingAttributes } from "lib/types";
import { postRequest } from "lib/fetchers/fetcher";
import { BreakfastShort } from "./types";

export const sendBreakfastRsvp = ({
  fields,
}: {
  fields: TrackingAttributes;
}): Promise<any> => {
  let resolvePromise: { (arg0): void } | null = null;

  const promise = new Promise((resolve, reject) => {
    resolvePromise = resolve;
  });

  window.tp = window.tp || [];
  window.tp.push([
    "init",
    () => {
      const userCookie = window?.tp?.userId?.getToken();

      const params = new URLSearchParams({
        userCookie,
        ...fields,
      });

      const url = `/api/subscriptionUtils/tracking/breakfast?${params}`;

      resolvePromise?.(postRequest(url, fields));
    },
  ]);

  return promise;
};

export const sortPreviousByYear = (list: BreakfastShort[], size: number) => {
  const sortedList: { [year: string]: BreakfastShort[] } = {};

  list.forEach((el) => {
    const year = new Date(el.dateTime).getFullYear();

    if (sortedList[year]) {
      sortedList[year] = [...sortedList[year], el];
    } else {
      sortedList[year] = [el];
    }
  });

  const allEntries = Object.entries(sortedList).sort(([key1], [key2]) => {
    return Number(key1) > Number(key2) ? -1 : 1;
  });

  let itemsLeft = size > list.length ? list.length : size;

  const result: [string, BreakfastShort[]][] = [];
  let i = 0;

  while (itemsLeft > 0) {
    const [key, valuesArray] = allEntries[i];

    if (itemsLeft >= valuesArray.length) {
      result.push([key, valuesArray]);
      itemsLeft = itemsLeft - valuesArray.length;
    } else {
      const cutItems = valuesArray.slice(0, itemsLeft);
      result.push([key, cutItems]);

      itemsLeft = itemsLeft - cutItems.length;
    }

    i++;
  }

  return result;
};
